import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideNoopAnimations } from '@angular/platform-browser/animations';

import { TokenStore } from './core/auth/token-store';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { MasterCompanyService } from './core/services/master-company.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideNoopAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    provideAppInitializer(() => {
      inject(TokenStore).migrateLegacyStorage();
    }),
    provideAppInitializer(() => {
      const master = inject(MasterCompanyService);
      return master.getMasterCompanyId().then(
        () => undefined,
        () => undefined,
      );
    }),
  ],
};
